import { WhatsappIUnlockModal } from "features/Integration/modules/WhatsappIUnlockModal/WhatsappIUnlockModal";
import React from "react";
import { useToggleState } from "utils/hooks";
import LockIcon from "@material-ui/icons/Lock";
import moduleStyle from "features/Common/modules/Badge/Badge.module.css";

export const WhatsappLock = () => {
  const [isInfoModalOpen, openInfoModal, closeInfoModal] =
    useToggleState(false);

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeInfoModal();
  };

  return (
    <>
      <div
        id="WhitelabelLock"
        onClick={openInfoModal}
        className={`${moduleStyle.chip} d-flex align-items-center fit_content pointer`}
      >
        <LockIcon className={moduleStyle.lockIcon} />
        <div className={`ml-2 ${moduleStyle.label}`}>Locked</div>
      </div>

      <WhatsappIUnlockModal open={isInfoModalOpen} onClose={handleClose} />
    </>
  );
};
